import {Injectable} from "@angular/core";

import '@capacitor-community/firebase-analytics';

import { Plugins } from '@capacitor/core';
import {Platform} from "@ionic/angular";
import {NavigationEnd, Router, RouterEvent} from "@angular/router";
import {filter} from "rxjs/operators";
import {Storage} from '@ionic/storage';

const { FirebaseAnalytics } = Plugins;

@Injectable({
    providedIn: 'root'
})
export default class AnalyticsService {

    constructor(private platform: Platform, private router: Router, private storage: Storage) {
        this.router.events.pipe(
            filter(e => e instanceof NavigationEnd)
        ).subscribe((e: RouterEvent) => {
            this.setScreenName(e.url);
        });

        this.storage.get('analytics')
            .then(enabled => {
                this.toggleAnalytics(!!enabled);
            });
    }

    private async setScreenName(screenName: string) {
        FirebaseAnalytics.setScreenName({
            screenName
        });
    }

    async initialize() {
        if (this.platform.is('ios') || this.platform.is('android')) {

        }
    }

    logEvent({ name, params }) {
        FirebaseAnalytics.logEvent({
            name,
            params
        });
    }

    toggleAnalytics(enabled = true) {
        FirebaseAnalytics.setCollectionEnabled({
            enabled
        });
    }
}
